import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { success, error } from 'plugins/toastr';
import { displayModal } from 'plugins/confirm-delete';
import { getNodeChildren } from 'catalog/selectors/node';
import NodeChildren from 'catalog/components/NodeChildren';
import { moveUpNode, moveDownNode, deleteNode } from 'catalog/actions/node';

const mapStateToProps = (state, ownProps) => ({
  children: getNodeChildren(state, ownProps),
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  moveUpNode: node => dispatch(moveUpNode(ownProps.catalog, node)),
  moveDownNode: node => dispatch(moveDownNode(ownProps.catalog, node)),
  deleteNode: node => dispatch(deleteNode(ownProps.catalog, node)),
});
class NodeChildrenPage extends React.Component {
  static propTypes = {
    catalog: PropTypes.string.isRequired,
    node: PropTypes.object.isRequired,
    children: PropTypes.array.isRequired,
    moveUpNode: PropTypes.func.isRequired,
    moveDownNode: PropTypes.func.isRequired,
    deleteNode: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.confirmDeleteNode = this.confirmDeleteNode.bind(this);
  }

  confirmDeleteNode(node) {
    displayModal(
      () => this.props.deleteNode(node),
      promise =>
        promise.then(
          _ => success('Noeud supprimé avec succès'),
          _ => error('Une erreur est survenue pendant la suppression du noeud')
        )
    );
  }

  render() {
    const { node, children, moveUpNode, moveDownNode } = this.props;

    return (
      <NodeChildren
        node={node}
        children={children}
        moveUpNode={moveUpNode}
        moveDownNode={moveDownNode}
        deleteNode={this.confirmDeleteNode}
      />
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  NodeChildrenPage
);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodeChildrenPage.js